import { render, staticRenderFns } from "./CircleTemplate.vue?vue&type=template&id=11ab23fd&scoped=true&"
import script from "./CircleTemplate.vue?vue&type=script&lang=js&"
export * from "./CircleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab23fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ab23fd')) {
      api.createRecord('11ab23fd', component.options)
    } else {
      api.reload('11ab23fd', component.options)
    }
    module.hot.accept("./CircleTemplate.vue?vue&type=template&id=11ab23fd&scoped=true&", function () {
      api.rerender('11ab23fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/CircleTemplate.vue"
export default component.exports